import { tienePermiso } from '../../../utils/permisosUtil';

export const permisosParametrosMixin = {
  computed: {
    permisosParametros() {
      return {
        accesoModulo: tienePermiso('sistema'),
      };
    },
  },
};
